export const getDropdownOptionsFromArray = array => array.map(element => ({ label: element, value: element }));
